import Immutable from 'immutable';
import * as types from '../../actions/applications/types';
import reducerCreator from '../../tools/reducer-creator';

const initialState = Immutable.fromJS({
  schoolUserRatings: [],
  rating: {},
  isRatingLoading: false,
  isUpdateRatingLoading: false,
  isDeleteRatingLoading: false,
  isSchoolUserRatingsLoading: false
});

export default reducerCreator(initialState, {
  [types.APPLICATION_SET_RATING_LOADING]: (state, { isLoading }) =>
    state.set('isRatingLoading', isLoading),

  [types.APPLICATION_SET_UPDATE_RATING_LOADING]: (state, { isLoading }) =>
    state.set('isUpdateRatingLoading', isLoading),

  [types.APPLICATION_SET_DELETE_RATING_LOADING]: (state, { isLoading }) =>
    state.set('isDeleteRatingLoading', isLoading),

  [types.APPLICATION_SET_SCHOOL_USER_RATINGS_LOADING]: (state, { isLoading }) =>
    state.set('isSchoolUserRatingsLoading', isLoading),

  [types.APPLICATION_SET_RATING]: (state, { applicationRating }) => 
    state.set('rating', Immutable.fromJS(applicationRating)),

  [types.APPLICATION_SET_SCHOOL_USER_RATINGS]: (state, { applicationSchoolUserRatings }) => 
    state.set('schoolUserRatings', Immutable.fromJS(applicationSchoolUserRatings)),

  [types.APPLICATION_RESET_RATINGS]: () =>
    initialState
});



// WEBPACK FOOTER //
// ./src/reducers/applications/application-ratings.js